import React, { CSSProperties, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import { DefaultContent } from "./AccountBenefitContent/DefaultContent";
import { FormsContent } from "./AccountBenefitContent/FormsContent";
import {
  CustomerOrigin,
  getQueryStringParams,
} from "@theatticusapp/atticus-shared-components";
import { formsApi } from "../../apis";
import { AtticusForm } from "../../models/AtticusForm";

// The app can send in multiple factors that will be used to determine the benefits content
//  this function will manage the priority of them
//  ex: http://app2.weareatticus.com/auth?signup=true&origin=MarketingApp&feature=notice
//  ex: http://app2.weareatticus.com/auth?signup=true&origin=FormsApp&feature=probate
//  ex: http://app2.weareatticus.com/auth?signup=true&origin=FormsApp
export const determineAccountBenefitsType = ({
  origin,
  feature,
}: {
  origin?: string;
  feature?: string;
}): AccountBenefitTypes | undefined => {
  // TODO: modify this logic are requirements become clear

  // features take precedence when determining benefit type
  if (feature === AccountBenefitTypes.noticeToCreditors) {
    return AccountBenefitTypes.noticeToCreditors;
  } else if (feature === AccountBenefitTypes.probateDetermination) {
    return AccountBenefitTypes.probateDetermination;
  }

  switch (origin) {
    case CustomerOrigin.FormsApp:
      return AccountBenefitTypes.forms;
  }
  return AccountBenefitTypes.default;
};

export enum AccountBenefitTypes {
  forms = "forms",
  noticeToCreditors = "notice",
  probateDetermination = "probate",
  default = "default",
}

export type BenefitItem = {
  imgs?: string[];
  title?: string;
  desc?: string;
  styles?: CSSProperties;
};

interface Props {
  benefit?: AccountBenefitTypes;
}

export const AccountBenefits = ({ benefit }: Props): JSX.Element => {
  const params = getQueryStringParams();
  const formIds = params?.formIds || undefined;
  const [form, setForm] = useState<AtticusForm>();
  const [benefitOverride, setBenefitOverride] = useState<AccountBenefitTypes>();

  useEffect(() => {
    (async () => {
      // just get the first form
      const [formId] = formIds?.split(",") || [];
      if (!formId) {
        setBenefitOverride(AccountBenefitTypes.default);
      } else {
        if (!isNaN(parseInt(formId, 10))) {
          const theForm = await formsApi.getFormLimited(parseInt(formId, 10));
          if (theForm) {
            setForm(theForm);
          } else {
            setBenefitOverride(AccountBenefitTypes.default);
          }
        }
      }
    })();
  }, []);

  const getContent = (): JSX.Element => {
    const activeBenefitType = benefitOverride || benefit;
    switch (activeBenefitType) {
      case AccountBenefitTypes.forms:
        return <FormsContent form={form} />; // should send form object
      case AccountBenefitTypes.noticeToCreditors:
        return <NoticeToCreditorsContent />;
      case AccountBenefitTypes.probateDetermination:
        return <ProbateDeterminationContent />;
      default:
        return <DefaultContent />;
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
      }}
    >
      {getContent()}
    </Box>
  );
};

const NoticeToCreditorsContent = (): JSX.Element => {
  return (
    <Box>
      {/* TODO: replace this temporary placeholder copy */}
      <Typography>Atticus helps you notify all creditors.</Typography>
    </Box>
  );
};

const ProbateDeterminationContent = (): JSX.Element => {
  return (
    <Box>
      {/* TODO: replace this temporary placeholder copy */}
      <Typography>
        Atticus can help you determine the version of probate your estate
        requires.
      </Typography>
    </Box>
  );
};
